<template>
  <div>
    <ValidationObserver ref="assignWorkerForm" slim>
      <form role="form" @submit.prevent="assign_worker_submit" class="row clearfix">
        <div class="col-12">
          <b-card v-if="order !== null" :header="'Assign to ' + order.order_ref" header-tag="h4" body-class="mb-3 pb-2">
            <div class="row">
              <div class="col-xl-6">
                <!-- Worker - Multiselect (Validated)-->
                <div class="col-xl-12">
                  <div class="row" v-if="!loading_workers">
                    <div class="col-12">
                      <div style="height: 300px">
                        <loadingCube :loadingMessage="'Workers'"></loadingCube>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="loading_workers">
                    <div class="col-12">
                      <!-- Worker -->
                      <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Worker" tag="div"
                        class="form-group">
                        <label class="form-label" for="worker">Worker</label>
                        <multiselect v-model="worker" id="worker" class="requiredField" :class="classes" name="worker"
                          placeholder="" :options="ms_opts.workers" :custom-label="worker_name"></multiselect>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>

                      <div class="row" v-if="worker !== null">
                        <div class="col-12">
                          <h3 class="font-weight-bolder bp_color">Worker Information</h3>
                          <p class="font-weight-bold">Below is information on the worker that you are about to assign.
                          </p>
                          <div class="row">
                            <div class="col-xl-5"><strong>Full Name:</strong></div>

                            <div class="col-xl-7">
                              <span v-if="notEmptyObject(worker_info)">{{ worker_info.first_name }} {{
                                worker_info.surname }}</span>
                            </div>
                            <div class="col-xl-5"><strong>Ref:</strong></div>
                            <div class="col-xl-7">{{ worker_info.internal_finance_ref }}</div>
                            <div class="col-12">
                              <p></p>
                            </div>
                            <div class="col-xl-5"><strong>Job Title:</strong></div>

                            <div class="col-xl-7">
                              <span v-if="notEmptyObject(worker_info) && worker_info.rel_profile.job_title !== null">{{
                                worker_info.rel_profile.job_title.job_title }}</span>
                            </div>
                            <div class="col-12">
                              <p></p>
                            </div>
                            <div class="col-xl-5"><strong>Personal Landline:</strong></div>
                            <div class="col-xl-7">
                              <span
                                v-if="notEmptyObject(worker_info) && notEmptyObject(phones) && phones.personal_landline !== null">
                                {{ phones.personal_landline.phone_number }}
                              </span>
                            </div>
                            <div class="col-xl-5"><strong>Personal Mobile:</strong></div>
                            <div class="col-xl-7">
                              <span
                                v-if="notEmptyObject(worker_info) && notEmptyObject(phones) && phones.personal_mobile !== null">
                                {{ phones.personal_mobile.phone_number }}
                              </span>
                            </div>
                            <div class="col-xl-5"><strong>Email (Website Login):</strong></div>
                            <div class="col-xl-7">
                              <span
                                v-if="notEmptyObject(worker_info) && notEmptyObject(emails) && emails.website_login !== null">{{
                                  emails.website_login.email_address }}</span>
                            </div>
                            <div class="col-12" v-if="crmType === 'payroll'">
                              <p></p>
                            </div>
                            <div class="col-12" v-if="crmType === 'payroll'">
                              <div class="pa_box"
                                :class="[notEmptyObject(worker_info) && worker_info.rel_services.personal_accident_insurance ? 'has_pa' : '']">
                                <span
                                  v-if="notEmptyObject(worker_info) && worker_info.rel_services.personal_accident_insurance">WORKER
                                  HAS PA INSURANCE</span>
                                <span v-else>WORKER HAS NO PA INSURANCE</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="row" v-if="current_assignments !== null && current_assignments.length > 0">
                    <div class="col-12">
                      <hr>
                      <h5 class="bp_color text-uppercase">Current Worker Assignments</h5>
                    </div>
                    <div class="col-12">
                      <div class="current_assignments" v-for="ca in current_assignments">
                        <h5 class="mb-0">{{ ca.company.company_name }}</h5>
                        <h5 class="bp_color">{{ ca.order_job.order_ref }} : {{
                          ca.order_job.rel_order_location.short_site_name }}</h5>
                        <p class="mb-0"><strong style="width: 100px;" class="d-inline-block">Location:</strong> {{
                          ca.order_job.rel_order_location.job_address_city_town }}</p>
                        <p class="mb-2"><strong style="width: 100px;" class="d-inline-block">Job Duration:</strong> {{
                          ca.order_job.rel_order_position.start_date | formatDate }}
                          - {{ ca.order_job.rel_order_position.end_date | formatDate }}
                        </p>
                        <div>
                          <div class="rate_desc">
                            <div class="rd_r_type">{{ ca.position_rate.rate_type }}</div>
                          </div>
                          <div class="rate_admin_fee">
                            <h5 class="mb-0 bp_color">{{ ca.position_rate.pay_amount | currency }} ({{
                              ca.position_rate.pay_type }})</h5>
                            <p class="mb-0">Admin Fee:
                              <span v-if="ca.position_rate.admin_fee_type === '£ (Pound)'">{{
                                ca.position_rate.admin_fee_amount | currency }}</span>
                              <span v-if="ca.position_rate.admin_fee_type === '% (Percentage)'">{{
                                ca.position_rate.admin_fee_amount | percentage }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6" v-if="errors.length === 0">
                <div class="row">
                  <!-- Client - Multiselect (Validated)-->
                  <div class="col-xl-12">
                    <!-- Employment Status - Multiselect (Validated) -->
                    <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Company" tag="div"
                      class="form-group">
                      <label class="form-label" for="company">Company</label>
                      <multiselect v-model="company" id="company" class="disabled" :class="classes" name="company"
                        placeholder="" :options="ms_opts.companys" :custom-label="company_name" :disabled="true">
                      </multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>

                  <div class="col-12 mb-3" v-if="crmType === 'payroll'">
                    <div class="pa_box" :class="[company.payroll_pa_insurance ? 'has_pa' : '']">
                      <span v-if="company.rel_payment_process_info.payroll_pa_insurance">COMPANY HAS PA INSURANCE</span>
                      <span v-else>COMPANY DOES NOT HAVE PA INSURANCE</span>
                    </div>
                  </div>

                  <!-- Orders - Multiselect (Validated) -->
                  <div class="col-xl-12">
                    <!-- Employment Status - Multiselect (Validated) -->
                    <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Order" tag="div"
                      class="form-group">
                      <label class="form-label" for="order">Order</label>
                      <multiselect v-model="order" id="order" :class="[classes, 'disabled']" name="order" placeholder=""
                        :disabled="true" :options="ms_opts.orders" :custom-label="order_label"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>

                  <ValidationProvider rules="" v-slot="{ errors, classes }" name="Order type" tag="div"
                    class="form-group col-12">
                    <label class="form-label" for="order_type">Order type</label>
                    <input type="text" v-model="order.order.order_type" class="form-input disabled" disabled="disabled"
                      id="order_type" name="order_type" placeholder="Order type">
                  </ValidationProvider>

                  <!-- Rate - Multiselect (Validated) -->
                  <div class="col-xl-12">
                    <!-- Employment Status - Multiselect (Validated) -->
                    <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Rate" tag="div"
                      class="form-group">
                      <label class="form-label" for="rate">Rate</label>
                      <multiselect v-model="rate" id="rate"
                        :class="[classes, order === null ? 'disabled' : 'requiredField']" name="rate" placeholder=""
                        :disabled="order === null" :options="ms_opts.rates" :custom-label="rate_label"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Start Date - Datepicker (Validated) -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Start Date" tag="div">
                      <label class="form-label" for="start_date">Start Date</label>
                      <datepicker v-model="assignment.start_date" id="start_date" name="start_date"
                        :input-class="['date-input', classes, order === null ? 'disabled' : 'requiredField']"
                        :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                        @input="select_start_date" :disabled="order === null" :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- End Date - Datepicker (Validated) -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{ errors, classes }" name="End Date" tag="div">
                      <label class="form-label" for="end_date">End Date</label>
                      <datepicker v-model="assignment.end_date" id="end_date" name="end_date"
                        :input-class="['date-input', classes, order === null ? 'disabled' : '']" :format="dateFormat"
                        :clear-button="true" :disabledDates="end_date_disabled"
                        clear-button-icon="far fa-calendar-times" @input="select_end_date" :disabled="order === null"
                        :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Is gang Leader - Toggle -->
                  <div v-show="order !== null" class="col-12 form-group" v-if="is_part_of_gang === false">
                    <div class="row">
                      <label class="col-md-8 cardLabel" for="is_gang_leader">Is Worker a Gang Leader?</label>
                      <div class="col-md-4">
                        <bootstrap-toggle v-model="assignment.is_gang_leader" name="is_gang_leader" id="is_gang_leader"
                          :options="{ on: 'Yes', off: 'No' }" />
                      </div>
                    </div>
                  </div>
                  <!-- Is gang Leader - Toggle -->
                  <div v-show="order !== null" class="col-12 form-group" v-if="assignment.is_gang_leader === false">
                    <div class="row">
                      <label class="col-md-8 cardLabel" for="is_part_of_gang">Is Worker part of a Gang?</label>
                      <div class="col-md-4">
                        <bootstrap-toggle v-model="is_part_of_gang" name="is_part_of_gang" id="is_part_of_gang"
                          :options="{ on: 'Yes', off: 'No' }" />
                      </div>
                    </div>
                  </div>
                  <!-- Gang Leader - Multiselect (Validated) -->
                  <div v-show="order !== null" v-if="is_part_of_gang === true" class="col-xl-12">
                    <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Gang Leader" tag="div"
                      class="form-group">
                      <label class="form-label" for="gang_leader">Gang Leader</label>
                      <multiselect v-model="gang_leader" id="gang_leader" class="requiredField" :class="classes"
                        name="gang_leader" placeholder="" :options="ms_opts.gang_leaders" :custom-label="worker_name2">
                      </multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div v-else>
                <h3>Cannot assign worker due to following problems:</h3>
                <div v-for="error in errors">
                  <span v-html="error"></span>
                </div>
                <div><button class="btn btn-light" @click="clearErrors">Clear errors</button></div>
              </div>
              <div class="col-12 form-group" v-if="errors.length === 0">
                <div class="row">
                  <label class="col-md-8 cardLabel" for="send_ass_email">Send Assignment Email</label>
                  <div class="col-md-4">
                    <bootstrap-toggle v-model="send_ass_email" name="send_ass_email" id="send_ass_email"
                      :options="{ on: 'Yes', off: 'No' }" />
                  </div>
                </div>
              </div>
              <div class="col-12" v-if="errors.length === 0">
                <button type="submit" class="btn orcaBtn w-100" :disabled="saving || (company === null && order === null && rate.length === 0 && assignment.start_date ===
                  null)">
                  <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving Assignment
                    ...</span>
                  <span v-else>Assign & Send Email</span>
                </button>
              </div>
            </div>
          </b-card>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';
import loadingCube from "loaders/order_loader";

export default {
  name: "order_assignment",
  components: { Multiselect, Datepicker, BootstrapToggle, loadingCube },
  data() {
    return {
      saving: false,
      loading_workers: false,

      ms_opts: {
        workers: [],
        companys: [],
        orders: [],
        rates: [],
        gang_leaders: []
      },

      worker: null,
      emails: {},
      phones: {},
      worker_info: {},
      company: null,
      order: null,
      rate: [],
      errors: [],
      current_assignments: null,

      assignment: {
        worker_id: null,
        company_id: null,
        order_job_id: null,
        position_rate_id: null,
        // Set assigned by values for creating the worker (current crm user)
        assigned_by_type: 'App\\Models\\Users\\User',
        assigned_by_id: this.$store.state.auth.me.id,
        start_date: null,
        end_date: null,
        assigned: true,
        is_gang_leader: false,
        gang_leader_id: null,
        // Set log values for creating the worker (current crm user)
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      },
      start_date_disabled: {
        to: "",
        from: "",
      },
      end_date_disabled: {
        to: "",
        from: "",
      },
      is_part_of_gang: false,
      gang_leader: null,
      send_ass_email: true
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'worker/all/to_assign/' + this.$store.state.assignments.assignment.order_job_id).then(workers => {

      // List those workers who match job type. Example Contract can be assigned only to Contrac, but not PAYE.

      // map worker employment type to an order type
      let wMapper = {
        'PAYE': 'PAYE',
        'Temporary (PAYE)': 'PAYE',
        'Self Employed (CIS) - Sole Trader': 'Contract',
        'Self Employed - Sole Trader': 'Contract',
        'Limited Company': 'Contract'
      };

      // map order type to employment types
      let oMapper = {
        'Contract': ['Contract'],
        'Internal': ['N/A'],
        'Payroll - Contract': ['Contract'],
        'Payroll - PAYE': ['PAYE'],
        'Permanent': ['Contract', 'PAYE'],
        'Temporary (PAYE)': ['PAYE']
      };

      workers.data.forEach((worker) => {

        let workerType = wMapper[worker.employment_type] ?? 'N/A';
        let orderTypes = oMapper[this.order.order.order_type] ?? [];

        if (orderTypes.includes(workerType)) {
          this.ms_opts.workers.push(worker);
        }
      });

      if (this.ms_opts.workers.length === 0) {
        this.errors.push('They are no workers fitted to this order.');
      }

      this.$nextTick(() => this.loading_workers = true)
    })
    axios.get(this.crmApiPath + 'company/' + this.$store.state.assignments.assignment.company_id).then(company => {
      this.company = company.data;
    })
    axios.get(this.crmApiPath + 'order/job/' + this.$store.state.assignments.assignment.order_job_id).then(order_job => {
      this.order = order_job.data
      this.ms_opts.rates = order_job.data.rel_order_position_rates;
    })
  },
  methods: {
    clearErrors() {
        this.errors = [];
    },
    checkBankDetailsComplete() {
      Object.entries(this.worker_info.bank_details_completion_progress).forEach(([name, state]) => {
        if (!state) {
          let message = "Please update worker bank info: <strong>" + name + "</strong>";
          this.errors.push(message);
        }
      });
    },
    worker_name2({ worker }) {
      return `${worker.internal_finance_ref} - ${worker.person.first_name} ${worker.person.surname}`;
    },
    worker_name({ first_name, surname, internal_finance_ref }) {
      return `${internal_finance_ref} - ${first_name} ${surname}`;
    },
    company_name({ company_name }) {
      return `${company_name}`;
    },
    order_label({ order_ref, rel_order_location }) {
      return `[${order_ref} : ${rel_order_location.short_site_name}] - ${rel_order_location.job_address_city_town}`;
    },
    rate_label({ pay_type, rate_type, pay_amount, admin_fee_type, admin_fee_amount }) {
      let a_fee = '';
      if (admin_fee_type === '£ (Pound)') {
        a_fee = this.$options.filters.currency(admin_fee_amount);
      }
      if (admin_fee_type === '% (Percentage)') {
        a_fee = this.$options.filters.percentage(admin_fee_amount);
      }
      let p_amount = this.$options.filters.currency(pay_amount);

      return `[${rate_type} : ${pay_type}] ` + p_amount + ` - [Admin Fee : ` + a_fee + `]`;
    },

    /* Date Format for datepicker */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    // Select actions on datepicker/multiselect
    select_start_date(selected_start_date) {
      if (selected_start_date != null) {
        this.assignment.start_date = this.$moment.utc(selected_start_date).format('YYYY-MM-DD');
      }
    },
    select_end_date(selected_end_date) {
      if (selected_end_date != null) {
        this.assignment.end_date = this.$moment.utc(selected_end_date).format('YYYY-MM-DD');
      }
    },

    assign_worker_submit() {
      this.$refs.assignWorkerForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.assignWorkerForm);
        }
        else {
          this.saving = true;
          let assign_promises = [];

          // save assignment
          assign_promises.push(new Promise(resolve => {
            if (this.gang_leader !== null) {
              this.assignment.gang_leader_id = this.gang_leader.worker.id;
            }
            axios.post(this.crmApiPath + 'assignments/worker_assignments', this.assignment).then(() => {
              resolve()
            });
          }))
          // send assignment email - (with key info doc)
          assign_promises.push(new Promise(resolve => {
            if (this.send_ass_email) {
              let first_name = '';
              let email = '';
              let all_assignments = [];

              first_name = this.worker.first_name;
              email = this.emails.website_login.email_address;
              all_assignments.push({ assignment: this.assignment });

              axios.post(this.crmApiPath + 'worker/email/all-assignments', {
                first_name: first_name,
                email: email,
                all_assignments: all_assignments
              }).then(() => {
                resolve()
              });
            }
            else {
              resolve();
            }

          }))

          Promise.all(assign_promises).then(() => {
            this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.worker.id);
            // Close current tab and open up profile worker
            this.$nextTick(() => {
              this.$bus.$emit('assignments::reload', { action: true });
              this.$tabs.close({
                path: this.$router.currentRoute.fullPath,
                to: '/workers/profile'
              });
              this.$tabs.refresh('/workers/profile', true);
            })
          });
        }
      });
    }
  },
  watch: {
    worker(val) {
      if (val !== null) {
        this.worker_info = {};
        this.emails = {};
        this.phones = {};
        this.current_assignments = null;
        this.errors = [];

        axios.get(this.crmApiPath + 'worker/' + val.id).then(worker => {
          this.worker_info = worker.data;
          this.checkBankDetailsComplete();

          axios.get(this.crmApiPath + 'contact_info/email/worker/' + worker.data.id).then(emails => {
            this.emails = emails.data;
          })
          axios.get(this.crmApiPath + 'contact_info/phone/worker/' + worker.data.id).then(phones => {
            this.phones = phones.data;
          })

          axios.get(this.crmApiPath + 'assignments/worker/current_assignments/' + val.id).then(current_assignments => {
            this.current_assignments = current_assignments.data;

            let current_ass_ids = [];
            this.$nextTick(() => {
              if (this.current_assignments.length > 0) {
                current_ass_ids = this.current_assignments.map(ca => ca.order_job_id)
              }
              if (current_ass_ids.length > 0 && current_ass_ids.includes(this.order.id)) {
                this.errors.push('Worker already assigned to this order.');
              }
              this.assignment.worker_id = val.id;
            })

          })
        });
      }
      else {
        this.worker_info = {};
        this.current_assignments = null;
        this.errors = [];
      }
    },
    company(val) {
      if (val !== null) {
        this.assignment.company_id = val.id;
      }
      else {
        this.order = null;
        this.rate = null;
        this.assignment = {
          worker_id: this.$store.state.workers.current_new_assignment.worker_id,
          company_id: null,
          order_job_id: null,
          position_rate_id: null,
          // Set assigned by values for creating the worker (current crm user)
          assigned_by_type: 'App\\Models\\Users\\User',
          assigned_by_id: this.$store.state.auth.me.id,
          start_date: null,
          end_date: null,
          assigned: true,
          is_gang_leader: false,
          gang_leader_id: null,
          // Set log values for creating the worker (current crm user)
          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        };
        this.start_date_disabled = {
          to: "",
          from: "",
        };
        this.end_date_disabled = {
          to: "",
          from: "",
        };
        this.is_part_of_gang = false;
        this.gang_leader = null;
      }
    },
    order(val) {
      if (val !== null) {
        this.assignment.order_job_id = val.id;

        // this.assignment.start_date = val.rel_order_position.start_date;
        this.assignment.start_date = this.$moment.utc().format('YYYY-MM-DD');
        this.assignment.end_date = val.rel_order_position.end_date;

        // pay_week_start_day

        // check if there is a timesheet week submitted for the order
        if (val.latest_submitted_ts_record !== null) {
          // disable start date to the start date of order
          this.start_date_disabled.to = new Date(this.$moment.utc(val.latest_submitted_ts_record.for_work_end_week_date)
            .day(val.order.company.rel_payment_process_info.pay_week_start_day)
            .subtract(7, 'days'))
          // disable end date to day after start date of order
          this.end_date_disabled.to = new Date(this.$moment.utc(val.latest_submitted_ts_record.for_work_end_week_date)
            .day(val.order.company.rel_payment_process_info.pay_week_start_day)
            .add(1, 'days'));
        }
        else {
          // check if there is an open timesheet week
          if (val.earliest_open_ts_record !== null) {
            // disable start date to the start date of order
            this.start_date_disabled.to = new Date(this.$moment.utc(val.earliest_open_ts_record.for_work_end_week_date)
              .day(val.order.company.rel_payment_process_info.pay_week_start_day)
              .subtract(7, 'days'));
            // disable end date to day after start date of order
            this.end_date_disabled.to = new Date(this.$moment.utc(val.earliest_open_ts_record.for_work_end_week_date)
              .day(val.order.company.rel_payment_process_info.pay_week_start_day)
              .add(1, 'days'));
          }
          else {
            // disable start date to the start date of order
            this.start_date_disabled.to = new Date(this.$moment.utc(val.rel_order_position.start_date)
              .day(val.order.company.rel_payment_process_info.pay_week_start_day)
              .subtract(7, 'days'));
            // disable end date to day after start date of order
            this.end_date_disabled.to = new Date(this.$moment.utc(val.rel_order_position.start_date)
              .day(val.order.company.rel_payment_process_info.pay_week_start_day)
              .add(1, 'days'));

          }
        }

        this.start_date_disabled.from = new Date(this.$moment.utc(val.rel_order_position.end_date));
        this.end_date_disabled.from = new Date(this.$moment.utc(val.rel_order_position.end_date));
      }
      else {
        this.rate = null;
        this.assignment.order_job_id = null;
        this.assignment.position_rate_id = null;
        this.assignment.start_date = null;
        this.assignment.end_date = null;

        this.start_date_disabled = {
          to: "",
          from: "",
        };
        this.end_date_disabled = {
          to: "",
          from: "",
        };
        this.is_part_of_gang = false;
        this.gang_leader = null;
      }
    },
    rate(val) {
      if (val) {
        this.assignment.position_rate_id = val.id;
      }
      else {
        this.assignment.position_rate_id = null;
      }
    },
    'assignment.start_date'(date) {
      if (this.order !== null) {
        if (date === null) {
          this.start_date_disabled.from = new Date(this.$moment.utc(this.order.rel_order_position.end_date).add(1, 'days'));
        }
        else {
          this.start_date_disabled.from = new Date(this.$moment.utc(this.order.rel_order_position.end_date));
        }
        this.end_date_disabled.to = new Date(this.$moment.utc(date));
      }
    },
    'assignment.end_date'(date) {
      if (this.order !== null) {
        if (date === null) {
          this.end_date_disabled.from = new Date(this.$moment.utc(this.order.rel_order_position.end_date).add(1, 'days'));
        }
        else {
          this.end_date_disabled.from = new Date(this.$moment.utc(this.order.rel_order_position.end_date));
        }
      }
    },
    'is_part_of_gang'(val) {
      if (val) {
        if (this.order !== null) {
          if (val) {
            axios.get(this.crmApiPath + 'assignments/order_job/list_gang_leaders/' + this.order.id).then(gang_leaders => {
              this.ms_opts.gang_leaders = gang_leaders.data
            });
          }
          else {
            this.ms_opts.gang_leaders = [];
          }
        }
      }
      else {
        this.ms_opts.gang_leaders = [];
      }

    }
  }
}
</script>

<style scoped lang="scss">
.pa_box {
  text-align: center;
  padding: 5px;
  background: $red;
  color: $white;

  &.has_pa {
    background: $green;
  }
}

.current_assignments {
  background: darken($card_background, 5%);
  padding: 15px;
  margin-bottom: 20px;

  .rate_desc,
  .rate_admin_fee {
    display: inline-block;
    vertical-align: middle;
  }

  .rate_desc {
    margin-right: 15px;

    .rd_r_type {
      font-weight: bold;
      font-size: 1.5rem;
    }
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}
</style>
